(async () => {
  const moneyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });
  const truncate = (string) => {
    if (string.length > 67) return string.substring(0, 67) + '...';
    return string;
  };
  const renderOOSIcon = (color) => {
    return `
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        fill="${color}"
        height="100%"
        width="100%"
        version="1.1"
        viewBox="0 0 460.775 460.775"
        xml:space="preserve"
        style="height: 100%; width: 100%; display: block;"
      >
        <path d="M285.08,230.397L456.218,59.27c6.076-6.077,6.076-15.911,0-21.986L423.511,4.565c-2.913-2.911-6.866-4.55-10.992-4.55  c-4.127,0-8.08,1.639-10.993,4.55l-171.138,171.14L59.25,4.565c-2.913-2.911-6.866-4.55-10.993-4.55  c-4.126,0-8.08,1.639-10.992,4.55L4.558,37.284c-6.077,6.075-6.077,15.909,0,21.986l171.138,171.128L4.575,401.505  c-6.074,6.077-6.074,15.911,0,21.986l32.709,32.719c2.911,2.911,6.865,4.55,10.992,4.55c4.127,0,8.08-1.639,10.994-4.55  l171.117-171.12l171.118,171.12c2.913,2.911,6.866,4.55,10.993,4.55c4.128,0,8.081-1.639,10.992-4.55l32.709-32.719  c6.074-6.075,6.074-15.909,0-21.986L285.08,230.397z"/>
      </svg>
    `;
  };
  const renderAuthIcon = (selector) => {
    return `
        <div style="width:100%; height: 100%" class="${selector}">
            <img
                src="https://cdn.shopify.com/s/files/1/1163/1976/files/authorized-check.png?v=1665167039"
                alt="Delivery Truck"
                height="50"
                width="50"
                loading="eager"
                style="width: 100%; height: 100%; object-fit: contain; filter: brightness(0);"
            >
        </div>
        `;
  };
  const renderPreOrderIcon = () => {
    return `<img
      src="https://cdn.shopify.com/s/files/1/1163/1976/files/preorder-icon_789aaab2-b3fc-4fa8-b2b8-e5e2ec722858.png?v=1665510873"
      alt="preorder icon"
      width="auto"
      height="auto"
      loading="lazy"
      style="width: 100%; height: 100%; object-fit: contain;"
    />`;
  };
  const getShippingMessage = (productShipping, collectionShipping, variantShipping) => {
    if (variantShipping.pdp_line_1) {
      if (
        variantShipping.pdp_line_1.includes(':') ||
        variantShipping.pdp_line_1?.toUpperCase().includes('ADD TO CART')
      ) {
        return variantShipping.pdp_line_2;
      } else {
        return variantShipping.pdp_line_1;
      }
    }
    if (productShipping.pdp_line_1) {
      if (
        productShipping.pdp_line_1.includes(':') ||
        productShipping.pdp_line_1?.toUpperCase().includes('ADD TO CART')
      ) {
        return productShipping.pdp_line_2;
      } else {
        return productShipping.pdp_line_1;
      }
    }
    if (collectionShipping.pdp_line_1) {
      if (
        collectionShipping.pdp_line_1.includes(':') ||
        collectionShipping.pdp_line_1?.toUpperCase().includes('ADD TO CART')
      ) {
        return collectionShipping.pdp_line_2;
      } else {
        return collectionShipping.pdp_line_1;
      }
    }
    return 'Ships same or next day';
  };
  const recentAnchor = document.querySelector('.js-recent-anchor');
  const recentlyViewedProducts = localStorage.getItem('recently_viewed_v2')
    ? JSON.parse(localStorage.getItem('recently_viewed_v2'))
    : [];
  const recentPdpShow =
    (window.location.pathname.includes('product') && recentlyViewedProducts.length > 1) ||
    (!window.location.pathname.includes('product') && recentlyViewedProducts.length > 0);
  if (recentlyViewedProducts && recentPdpShow) {
    const updatedRecentlyViewedProducts = [];
    const handles = recentlyViewedProducts.map((p) => p.handle);
    fetch(`https://www.fpapplications.com/recent?currency=${CURRENCY_CODE}&handles=${handles.join(',')}`)
      .then((res) => res.json())
      .then((res) => {
        if (res) {
          for (let i = 0; i < res.length; i++) {
            const product = res[i];
            const existingSlide = recentAnchor.children[i];
            if (!existingSlide) {
              break;
            }
            if (existingSlide.dataset.handle !== product.handle) {
              existingSlide.remove();
              recentlyViewedProducts.splice(i, 1);
              continue;
            }
            const title = truncate(product.title);
            const url = `/products/${product.handle}`;
            const id = product.first_variant_id;
            const image = product.img_src;
            const badge = product.reviews_badge;
            const price = product.price;
            const compareAtPrice = product.compare_at_price;
            const available =
              product.calculated_published &&
              ((product.inventory_quantity > 0 && product.tracks_inventory === 1) ||
                product.tracks_inventory === 0 ||
                product.inventory_policy === 'continue');
            const preorder =
              product.inventory_policy === 'continue' &&
              product.tracks_inventory === 1 &&
              product.inventory_quantity <= 0;
            const shipping = product.custom_processing_time ? JSON.parse(product.custom_processing_time) : {};
            const collectionShipping = product.vendor_processing_time ? JSON.parse(product.vendor_processing_time) : {};
            const variantShipping = product.variant_processing_time ? JSON.parse(product.variant_processing_time) : {};
            const onSale =
              (shipping.pdp_line_1 && shipping.pdp_line_1.includes(':')) ||
              (!shipping.pdp_line_1 && collectionShipping.pdp_line_1 && collectionShipping.pdp_line_1.includes(':')) ||
              (!shipping.pdp_line_1 &&
                !collectionShipping.pdp_line_1 &&
                variantShipping.pdp_line_1 &&
                variantShipping.pdp_line_1.includes(':')) ||
              compareAtPrice > price;
            const shippingMessage = getShippingMessage(shipping, collectionShipping, variantShipping);
            if (existingSlide) {
              existingSlide.querySelector('.js-recent-image').src = image;
              existingSlide.querySelector('.js-recent-image').alt = title;
              existingSlide.querySelector('.js-recent-title').textContent = title;
              existingSlide.querySelector('.js-recent-price').textContent = moneyFormatter.format(price);

              const comparePriceElem = existingSlide.querySelector('.js-recent-compare-at-price');
              if (compareAtPrice > price) {
                if (comparePriceElem) {
                  comparePriceElem.textContent = moneyFormatter.format(compareAtPrice);
                  comparePriceElem.style.display = '';
                } else {
                  const compareElem = document.createElement('p');
                  compareElem.className = 'recent__grid__slide__price--compare';
                  compareElem.textContent = moneyFormatter.format(compareAtPrice);
                  existingSlide.querySelector('.recent__grid__slide__price-box')?.appendChild(compareElem);
                }
              } else if (comparePriceElem) {
                comparePriceElem.style.display = 'none';
              }

              existingSlide.querySelector('.js-recent-stock').innerHTML = preorder
                ? `<div class="recent__grid__slide__stock--icon">
                                ${renderPreOrderIcon()}
                            </div><span class="recent__grid__slide__stock--text">Pre Order</span>`
                : available
                ? `<div class="recent__grid__slide__stock--icon">${renderAuthIcon(
                    'cart__icon--authorized--blue'
                  )}</div><span class="recent__grid__slide__stock--text">In Stock</span>`
                : `<div class="recent__grid__slide__stock--icon" style="padding: 4px">${renderOOSIcon(
                    'rgb(180,0,0)'
                  )}</div><span class="recent__grid__slide__stock--text" style="color:rgb(180,0,0)">Out Of Stock</span>`;

              const shippingElem = existingSlide.querySelector('.js-recent-processing-time');
              if (shippingMessage) {
                shippingElem.textContent = shippingMessage;
                shippingElem.style.display = '';
              }

              const atcBtn = existingSlide.querySelector('.js-recent-atc');
              if (available) {
                atcBtn.textContent = 'Add To Cart';
                atcBtn.classList.remove('recent__atc--out-of-stock');
                atcBtn.disabled = false;
              } else {
                atcBtn.textContent = 'Out Of Stock';
                atcBtn.classList.add('recent__atc--out-of-stock');
                atcBtn.disabled = true;
                shippingElem.style.visibility = 'hidden';
              }

              const saleElem = existingSlide.querySelector('.js-recent-sale');
              if (onSale) {
                if (!saleElem) {
                  const saleDiv = document.createElement('div');
                  saleDiv.className = 'recent__sale';
                  saleDiv.innerHTML = `<div class="recent__sale__inner">SALE</div>`;
                  existingSlide.querySelector('.recentV2__grid__slide__card')?.appendChild(saleDiv);
                }
              } else if (saleElem) {
                saleElem.remove();
              }
            }
            updatedRecentlyViewedProducts.push({
              handle: product.handle,
              first_variant_id: product.first_variant_id,
              title: product.title,
              img_src: product.img_src,
              reviews_badge: product.reviews_badge,
              price: product.price * 100,
              compare_at_price: product.compare_at_price * 100,
              available: available,
              preorder: preorder,
              processing_time: shippingMessage,
              on_sale: onSale,
            });
          }
          localStorage.setItem('recently_viewed_v2', JSON.stringify(updatedRecentlyViewedProducts));
        }
      })
      .catch((err) => {
        console.error(err);
        document.querySelector('.js-recent').remove();
      });
  } else {
    console.log('No recently viewed products found');
    document.querySelector('.js-recent').remove();
  }
})();

const recenttest = [
  {
    handle: 'vive-hasdasdealth-mob1033-upright-walker-new',
    first_variant_id: 45767870972093,
    title: 'Vive Health MOB1033 Upright Walker New',
    img_src:
      'https://cdn.shopify.com/s/files/1/1163/1976/files/image_1024_5231337c-840e-4cd7-97b1-c07ce5ed0919.png?v=1771626949',
    reviews_badge:
      "<div style='display:none' class='jdgm-prev-badge' data-average-rating='4.66' data-number-of-reviews='29' data-number-of-questions='0'> <span class='jdgm-prev-badge__stars' data-score='4.66' tabindex='0' aria-label='4.66 stars' role='button'> <span class='jdgm-star jdgm--on'></span><span class='jdgm-star jdgm--on'></span><span class='jdgm-star jdgm--on'></span><span class='jdgm-star jdgm--on'></span><span class='jdgm-star jdgm--half'></span> </span> <span class='jdgm-prev-badge__text'> 29 reviews </span> </div>",
    price: 179.99,
    compare_at_price: null,
    available: true,
    preorder: false,
    processing_time: 'Ships same or next day',
    on_sale: false,
  },
  {
    handle: 'vive-health-mob1033-upright-walker-new',
    first_variant_id: 45767870972093,
    title: 'Vive Health MOB1033 Upright Walker New',
    img_src:
      'https://cdn.shopify.com/s/files/1/1163/1976/files/image_1024_5231337c-840e-4cd7-97b1-c07ce5ed0919.png?v=1771626949',
    reviews_badge:
      "<div style='display:none' class='jdgm-prev-badge' data-average-rating='4.66' data-number-of-reviews='29' data-number-of-questions='0'> <span class='jdgm-prev-badge__stars' data-score='4.66' tabindex='0' aria-label='4.66 stars' role='button'> <span class='jdgm-star jdgm--on'></span><span class='jdgm-star jdgm--on'></span><span class='jdgm-star jdgm--on'></span><span class='jdgm-star jdgm--on'></span><span class='jdgm-star jdgm--half'></span> </span> <span class='jdgm-prev-badge__text'> 29 reviews </span> </div>",
    price: 179.99,
    compare_at_price: null,
    available: true,
    preorder: false,
    processing_time: 'Ships same or next day',
    on_sale: false,
  },
  {
    handle:
      'vive-health-mob1058-mobility-scooter-automatic-folding-220-lbs-capacity-24v-li-ion-3-73-mph-11-3-miles-black-new',
    first_variant_id: 45767871201469,
    title:
      'Vive Health MOB1058 Mobility Scooter Automatic Folding 220 lbs. Capacity 24V Li-Ion 3.73 MPH 11.3 Miles Black New',
    img_src:
      'https://cdn.shopify.com/s/files/1/1163/1976/files/image_1024_f56a83cc-6409-4e60-8869-8812bf9cdda2.png?v=1771626950',
    reviews_badge:
      "<div style='display:none' class='jdgm-prev-badge' data-average-rating='3.00' data-number-of-reviews='1' data-number-of-questions='0'> <span class='jdgm-prev-badge__stars' data-score='3.00' tabindex='0' aria-label='3.00 stars' role='button'> <span class='jdgm-star jdgm--on'></span><span class='jdgm-star jdgm--on'></span><span class='jdgm-star jdgm--on'></span><span class='jdgm-star jdgm--off'></span><span class='jdgm-star jdgm--off'></span> </span> <span class='jdgm-prev-badge__text'> 1 review </span> </div>",
    price: 899.99,
    compare_at_price: null,
    available: false,
    preorder: false,
    processing_time: 'Ships Same or Next Day',
    on_sale: true,
  },
  {
    handle: 'anker-solix-e10-automatic-backup-kit-6-24kwh-lfp-battery-10-30kw-turbo-output-new',
    first_variant_id: 46425529712829,
    title: 'Anker Solix E10 Automatic Backup Kit 6-24kWh LFP Battery 10-30kW Turbo Output New',
    img_src:
      'https://cdn.shopify.com/s/files/1/1163/1976/files/E10_PCS_PACK_ATS_d321ad7e-8011-4c06-81b8-fe6ecc7cccf2_1000x-1771877571059.png?v=1771877572',
    reviews_badge:
      "<div style='display:none' class='jdgm-prev-badge' data-average-rating='0.00' data-number-of-reviews='0' data-number-of-questions='0'> <span class='jdgm-prev-badge__stars' data-score='0.00' tabindex='0' aria-label='0.00 stars' role='button'> <span class='jdgm-star jdgm--off'></span><span class='jdgm-star jdgm--off'></span><span class='jdgm-star jdgm--off'></span><span class='jdgm-star jdgm--off'></span><span class='jdgm-star jdgm--off'></span> </span> <span class='jdgm-prev-badge__text'> No reviews </span> </div>",
    price: 5799,
    compare_at_price: null,
    available: true,
    preorder: false,
    processing_time: 'Ships in (est) 3-5 business days',
    on_sale: true,
  },
  {
    handle: 'vevor-pcp-air-compressor-double-cylinder-4500-psi-auto-stop-water-and-fan-cooling-new',
    first_variant_id: 46038759669949,
    title: 'Vevor PCP Air Compressor Double Cylinder 4500 PSI Auto-Stop Water and Fan Cooling New',
    img_src:
      'https://cdn.shopify.com/s/files/1/1163/1976/files/us_GYQSYSJ2GNZS6QWPP001V1_original_img-v1_diving-compressor-m100-1765231370128_963ea31d-801b-49e9-a3ec-9146799791ff.png?v=1771627006',
    reviews_badge:
      "<div style='display:none' class='jdgm-prev-badge' data-average-rating='0.00' data-number-of-reviews='0' data-number-of-questions='0'> <span class='jdgm-prev-badge__stars' data-score='0.00' tabindex='0' aria-label='0.00 stars' role='button'> <span class='jdgm-star jdgm--off'></span><span class='jdgm-star jdgm--off'></span><span class='jdgm-star jdgm--off'></span><span class='jdgm-star jdgm--off'></span><span class='jdgm-star jdgm--off'></span> </span> <span class='jdgm-prev-badge__text'> No reviews </span> </div>",
    price: 599.99,
    compare_at_price: null,
    available: true,
    preorder: false,
    processing_time: 'Most orders ship out the same or next business day',
    on_sale: false,
  },
  {
    handle: 'comfortbilt-hp22i-ss-2-800-sq-ft-pellet-stove-fireplace-insert-47-lb-hopper-capacity-black-new',
    first_variant_id: 30217975758930,
    title: 'ComfortBilt HP22I-SS 2,800 sq. ft. Pellet Stove Fireplace Insert 47 lb Hopper Capacity Black New',
    img_src: 'https://cdn.shopify.com/s/files/1/1163/1976/files/insert_ss-removebg.png?v=1771618557',
    reviews_badge:
      "<div style='display:none' class='jdgm-prev-badge' data-average-rating='4.67' data-number-of-reviews='39' data-number-of-questions='2'> <span class='jdgm-prev-badge__stars' data-score='4.67' tabindex='0' aria-label='4.67 stars' role='button'> <span class='jdgm-star jdgm--on'></span><span class='jdgm-star jdgm--on'></span><span class='jdgm-star jdgm--on'></span><span class='jdgm-star jdgm--on'></span><span class='jdgm-star jdgm--half'></span> </span> <span class='jdgm-prev-badge__text'> 39 reviews </span> </div>",
    price: 2599,
    compare_at_price: null,
    available: true,
    preorder: false,
    processing_time: 'Ships same or next day',
    on_sale: true,
  },
  {
    handle: 'comfortbilt-hp22i-2-800-sq-ft-pellet-stove-fireplace-insert-47-lb-hopper-capacity-black-new',
    first_variant_id: 21323748311122,
    title: 'ComfortBilt HP22I 2,800 sq. ft. Pellet Stove Fireplace Insert 47 lb Hopper Capacity Black New',
    img_src: 'https://cdn.shopify.com/s/files/1/1163/1976/files/hp22-removebg.png?v=1771617816',
    reviews_badge:
      "<div style='display:none' class='jdgm-prev-badge' data-average-rating='4.67' data-number-of-reviews='39' data-number-of-questions='1'> <span class='jdgm-prev-badge__stars' data-score='4.67' tabindex='0' aria-label='4.67 stars' role='button'> <span class='jdgm-star jdgm--on'></span><span class='jdgm-star jdgm--on'></span><span class='jdgm-star jdgm--on'></span><span class='jdgm-star jdgm--on'></span><span class='jdgm-star jdgm--half'></span> </span> <span class='jdgm-prev-badge__text'> 39 reviews </span> </div>",
    price: 2599,
    compare_at_price: null,
    available: true,
    preorder: true,
    processing_time: 'Ships same or next day',
    on_sale: true,
  },
  {
    handle: 'duromax-xp13000eh-10500w-13000w-electric-start-dual-fuel-generator-new',
    first_variant_id: 22553651871826,
    title: 'DuroMax XP13000EH 10500W/13000W Electric Start Dual Fuel Generator New',
    img_src:
      'https://cdn.shopify.com/s/files/1/1163/1976/files/xp13000eh_01_1_a2914d39-f265-47d9-8edc-cd1f09a7cf0c.png?v=1771618275',
    reviews_badge:
      "<div style='display:none' class='jdgm-prev-badge' data-average-rating='4.80' data-number-of-reviews='443' data-number-of-questions='5'> <span class='jdgm-prev-badge__stars' data-score='4.80' tabindex='0' aria-label='4.80 stars' role='button'> <span class='jdgm-star jdgm--on'></span><span class='jdgm-star jdgm--on'></span><span class='jdgm-star jdgm--on'></span><span class='jdgm-star jdgm--on'></span><span class='jdgm-star jdgm--on'></span> </span> <span class='jdgm-prev-badge__text'> 443 reviews </span> </div>",
    price: 1299,
    compare_at_price: 1499,
    available: true,
    preorder: false,
    processing_time: 'Ships same or next day',
    on_sale: true,
  },
];
